import { Model }            from 'backbone';

class ReportingMetaDataModel extends Model {

    initialize() {

    }

    defaults() {
        const def = {};
        def.id = '';
        def.name = '';
        def.dataSource = '';
        def.isAggregate = '';
        def.ignoreNull = '';

        return def;
    }

}

export default ReportingMetaDataModel;